import type { CameraConfig, CameraGridSize } from "../types/camera";
import type { GridPoint } from "../types/grid";
import type { LevelCameraMode } from "../types/level";

export interface CameraManagerContract {
  createConfig(initialCenter: GridPoint, mode?: LevelCameraMode): CameraConfig;
}

export interface CameraPreset {
  readonly viewportTiles: CameraGridSize;
  readonly safeZoneTiles: CameraGridSize;
}

export const CAMERA_PRESET: CameraPreset = Object.freeze({
  viewportTiles: Object.freeze({ width: 16, height: 9 }),
  safeZoneTiles: Object.freeze({ width: 7, height: 4 }),
});

export const TILE_SIZE = 24;

export function createCameraConfig(initialCenter: GridPoint, mode?: LevelCameraMode): CameraConfig {
  return {
    initialCenter: { x: initialCenter.x, y: initialCenter.y },
    viewportTiles: {
      width: CAMERA_PRESET.viewportTiles.width,
      height: CAMERA_PRESET.viewportTiles.height,
    },
    safeZoneTiles: {
      width: CAMERA_PRESET.safeZoneTiles.width,
      height: CAMERA_PRESET.safeZoneTiles.height,
    },
    mode: mode ?? "follow",
  };
}

export function getCameraResetPixelCenter(cameraConfig: CameraConfig): { x: number; y: number } {
  return {
    x: cameraConfig.initialCenter.x * TILE_SIZE,
    y: cameraConfig.initialCenter.y * TILE_SIZE,
  };
}
